var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.active === 0)?_c('index'):_vm._e(),(_vm.active === 1)?_c('mycustomform'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }